@if(menuItems && !disabled) {
<div class="dropdown-container">
  <button
    #triggerBtn
    [type]="type"
    [disabled]="disabled"
    (click)="toggleDropdown()"
    (keydown)="onTriggerKeydown($event)"
    [attr.aria-haspopup]="'menu'"
    [attr.aria-expanded]="showDropdown"
    [ngClass]="customClass">
    <ng-container *ngIf="icon && iconPosition === 'left'">
      <i class="fa fa-chevron-down"></i>
    </ng-container>
    {{ label }}
    <ng-container *ngIf="icon && iconPosition === 'right'">
      <i class="fa fa-chevron-down"></i>
    </ng-container>
  </button>

  <div
    class="dropdown-list"
    *ngIf="showDropdown"
    role="menu"
    #menuPanel>
    <div class="dropdown-item">
      <div *ngFor="let category of objectKeys(menuItems)">
        <div class="category-title" role="presentation">{{ category }}</div>
        <div *ngFor="let menuItem of menuItems[category]; let innerIndex = index">
          <div *ngIf="menuItem.display === 'y'">
            <button
              #mi
              class="menu-item"
              [class.menu-item-active]="menuItem.menu_id === activeMenuId"
              role="menuitem"
              [attr.tabindex]="getFlatIndex(category, innerIndex) === activeIndex ? 0 : -1"
              (click)="OnMenuClick(menuItem)"
              (keydown)="onItemKeydown($event, menuItem, getFlatIndex(category, innerIndex))">
              <i class="fa {{getMenuIcon(menuItem.menu_id)}} menu-item-icon" aria-hidden="true"></i>
              <span>{{ menuItem.menu_label }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
}
